import React from "react";

const DEFAULT_PATH = {
  currentSlug: "",
  setContent: () => {},
  redirectUserToExternalSite: () => {}
};

const pathContext = React.createContext(DEFAULT_PATH);

export default pathContext;
